import React from "react";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Checkbox as MuiCheckbox,
} from "@mui/material";
import PropTypes from "prop-types";
import { convertToDefEventPara } from "../helper.js";

Checkbox.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showErrorText: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default function Checkbox(props) {
  const {
    item,
    value = false,
    onChange,
    error,
    showErrorText = false,
    disabled = false,
  } = props;

  let helperText = "";
  if (showErrorText) helperText = error;

  return (
    <FormControl
      {...(error && { error: true })}
      sx={{ width: "100%" }}
      size="medium"
    >
      <FormControlLabel
        control={
          <MuiCheckbox
            name={item.name}
            color="primary"
            checked={value || false}
            disabled={disabled}
            onChange={(e) =>
              onChange(convertToDefEventPara(item.name, e.target.checked))
            }
          />
        }
        label={item.label}
      />
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
}
